<div role="dialog" aria-modal="true">
  <div class="modal-header">
    <h2 class="modal-title h4">Add a trusted service to your team</h2>
  </div>
  <form #ngForm="ngForm" (ngSubmit)="ngForm.valid && submit()">
    <div class="modal-body" style="height: 100px">
      <div>
        <span>Select the service that you own</span>
        <label style="width: 100%">
          <ng-select
            name="TeamName"
            [(ngModel)]="team"
            [items]="ownerTeamList"
            groupBy="ring"
            placeholder="Start typing"
            [virtualScroll]="true"
            required
            data-test="TeamName"
            #teamName="ngModel">
            <ng-template ng-option-tmp let-item="item">
              <ng-container>
                <label title="{{ item.label }}" attr.data-test="{{ item.label }}">
                  {{ item.label }}
                </label>
              </ng-container>
            </ng-template>
          </ng-select>
        </label>
      </div>
    </div>
    <div class="modal-body" style="height: 100px">
      <div>
        <span>Select the service to trust</span>
        <label style="width: 100%">
          <ng-select
            name="TrustedTeamName"
            [(ngModel)]="trustedTeam"
            [items]="trustedTeamList"
            groupBy="ring"
            placeholder="Start typing"
            [virtualScroll]="true"
            required
            data-test="TrustedTeamName"
            #trustedTeamName="ngModel">
            <ng-template ng-option-tmp let-item="item">
              <ng-container>
                <label title="{{ item.label }}" attr.data-test="{{ item.label }}">
                  {{ item.label }}
                </label>
              </ng-container>
            </ng-template>
          </ng-select>
        </label>
        <em *ngIf="isSelfTrust">A service cannot trust itself</em>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="ngForm.invalid || isSelfTrust">OK</button>
      <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancel</button>
    </div>
  </form>
</div>
